import { createFileRoute } from '@tanstack/react-router';
import { Suspense } from 'react';
import { Page } from '@trukt/ui/Page';
import { PageLayout } from '@trukt/ui/PageLayout';
import { Loading } from '@trukt/ui/Loading';
import OrderView from '../order/view/order-view';

const Component = () => (
  <Suspense
    fallback={
      <PageLayout
        header={<></>}
        content={<Loading />}
        topic={<Loading size="sm" />}
        contentAside={<></>}
      />
    }
  >
    <Page route={{ Component: OrderView }} />
  </Suspense>
);

export const Route = createFileRoute('/orders/$orderGuid')({ component: Component });
